import React from 'react'
import {FlexContainer} from '../../Atoms/Containers'
import {MBContentBodyItemDisabledTypography, MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {Spacer} from '../../../../Common/Components/Spacer'
import {MBStepDivider} from '../../Atoms/Dividers'
import {Color} from '../../Styles'
import {MemberFilePenIcon} from '../../Atoms/Icons/MemberFilePenIcon'
import {MemberFileCircleCheckIcon} from '../../Atoms/Icons/MemberFileCircleCheckIcon'
import {MemberCircleCheckIcon} from '../../Atoms/Icons/MemberCheckCircleIcon'

type Steps =
  'enter'
  | 'confirm'
  | 'complete'

type Activity =
  'signup'
  | 'edit'
  | 'leave'

interface StepGuideProps {
  activity: Activity
  current: Steps
}

const STEP_LISTS: { [activityKey: string]: StepListItemProps[] } = {
  'signup': [
    {type: 'enter', name: '入力', className: 'step-enter'},
    {type: 'confirm', name: '確認', className: 'step-confirm'},
    {type: 'complete', name: '完了', className: 'step-complete'},
  ],
  'edit': [
    {type: 'enter', name: '変更', className: 'step-enter'},
    {type: 'confirm', name: '確認', className: 'step-confirm'},
    {type: 'complete', name: '完了', className: 'step-complete'},
  ],
  'leave': [
    {type: 'enter', name: '入力', className: 'step-enter'},
    {type: 'confirm', name: '確認', className: 'step-confirm'},
    {type: 'complete', name: '完了', className: 'step-complete'},
  ],
}

const StepGuide: React.VFC<StepGuideProps> = (props) => {

  const stepPropList: StepListItemProps[] = STEP_LISTS[props.activity]

  return (
    <Spacer mb={'14px'}>
      <FlexContainer data-testid={'step-guide'} justifyContent={'center'} gap={'12px'}>
        {stepPropList.map((item, idx) =>
          <FlexContainer key={idx} alignItems={'center'} gap={'12px'}>
            {idx !== 0 && <MBStepDivider/>}
            <StepItem
              stepType={item.type}
              label={item.name}
              disable={props.current !== item.type}
            />
          </FlexContainer>,
        )}
      </FlexContainer>
    </Spacer>
  )
}


interface StepListItemProps {
  type: Steps
  name: string
  className: string
  isCurrent?: boolean
}

type StepItemProps = {
  stepType: Steps
  label: string
  disable: boolean
}
const StepItem: React.VFC<StepItemProps> = (props) => {
  return (
    <FlexContainer alignItems={'center'} gap={'5px'}>
      {props.disable ? getDisabledIcon(props.stepType) : getIcon(props.stepType)}
      {props.disable ? (
        <MBContentBodyItemDisabledTypography>{props.label}</MBContentBodyItemDisabledTypography>
      ) : (
        <MBContentSubTitleTypography>{props.label}</MBContentSubTitleTypography>
      )}
    </FlexContainer>
  )
}

const getIcon = (stepType: Steps): JSX.Element => {
  if (stepType === 'enter') {
    return <div data-testid={'file-pen-icon'}>
      <MemberFilePenIcon/>
    </div>
  }
  if (stepType === 'confirm') {
    return <div data-testid={'file-circle-check-icon'}>
      <MemberFileCircleCheckIcon/>
    </div>
  }
  return <div data-testid={'circle-check-icon'}>
    <MemberCircleCheckIcon/>
  </div>
}
const getDisabledIcon = (stepType: Steps): JSX.Element => {
  if (stepType === 'enter') {
    return <div data-testid={'file-pen-disable-icon'}>
      <MemberFilePenIcon color={Color.Grey600}/>
    </div>
  }
  if (stepType === 'confirm') {
    return <div data-testid={'file-circle-check-disable-icon'}>
      <MemberFileCircleCheckIcon color={Color.Grey600}/>
    </div>
  }
  return <div data-testid={'circle-check-disable-icon'}>
    <MemberCircleCheckIcon color={Color.Grey600}/>
  </div>
}

export default StepGuide
